/** Resumen de las sesiones de enfoque (puro). */
import { weekPeriods, type EngineSettings, type LocalDate } from '@habitos/engine';
import type { FocusRec } from './model';

export interface FocusStats {
  todayMinutes: number;
  weekMinutes: number;
  sessionsWeek: number;
  byHabit: { habitId: string | null; minutes: number }[];
}

export function focusStats(records: FocusRec[], today: LocalDate, settings: EngineSettings): FocusStats {
  const week = weekPeriods(settings, today, today)[0]!;
  const live = records.filter((r) => !r.deletedAt);
  const inWeek = live.filter((r) => r.logicalDate >= week.start && r.logicalDate <= week.end);
  const minutes = (rs: FocusRec[]) => Math.round(rs.reduce((n, r) => n + r.activeSeconds, 0) / 60);
  const by = new Map<string | null, number>();
  for (const r of inWeek) by.set(r.habitId, (by.get(r.habitId) ?? 0) + r.activeSeconds);
  return {
    todayMinutes: minutes(live.filter((r) => r.logicalDate === today)),
    weekMinutes: minutes(inWeek),
    sessionsWeek: inWeek.length,
    byHabit: [...by.entries()].map(([habitId, s]) => ({ habitId, minutes: Math.round(s / 60) })).sort((a, b) => b.minutes - a.minutes),
  };
}
